export { default } from './AlertSettings';
